import { language as defaultLanguage } from "../../settings";

import thaiLang from "../../image/flag/thailand.svg";
import englishLang from "../../image/flag/uk.svg";
// import chineseLang from "../../image/flag/china.svg";

const options = [
  {
    languageId: "english",
    locale: "en",
    text: "English",
    icon: englishLang,
  },
  {
    languageId: "thai",
    locale: "th",
    text: "Thai",
    icon: thaiLang,
  },
  // {
  //   languageId: "chinese",
  //   locale: "zh",
  //   text: "Chinese",
  //   icon: chineseLang,
  // },
];

function getCurrentLanguage(lang) {
  const selectedId = lang || localStorage.getItem("appLanguage") || defaultLanguage;
  return options.find((item) => item.languageId === selectedId) || options[0];
}

function setLanguage(langId) {
  localStorage.setItem("appLanguage", langId);
}

export default {
  defaultLanguage,
  options,
};

export { getCurrentLanguage, setLanguage };
